"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeof process !== 'undefined' && process.versions != null && process.versions.node != null && process.title !== 'browser';